'use strict';

const processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./survey/survey-app'));
});

require('core/components/spinner');
